export default (context) => {
  return {
    httpEndpoint: process.env.GRAPHQL_URL,
    getAuth: () => {
      // For some reason this token always work (refresh token)
      // But the auth_token works for a while. My guess is that it refreshed.
      // I think the issue is that this function is only called once to get the token,
      // instead of on each request. Not sure right now and it isn't worth the effort
      // of discovering the issue at the moment (since the refresh token always work)
      // TODO: Make this work with auth_token even if it is refreshed.
      const token = context.app.$cookies.get('refresh._token.uptogether')
      return `Bearer ${token}`
    },
  }
}
